import Progbar from '@pages/GoalsPage/components/Progbar';

import { Title, Text, ProgbarContainer } from '../OnboardingStyles';

const YourPlan = () => (
  <>
    <ProgbarContainer>
      <Progbar currentStep={4} totalSteps={5} />
    </ProgbarContainer>
    <Title>Your Comprehensive Strategic Plan</Title>
    <br />
    <Text>
      Jamie will leverage this detailed blueprint to incorporate all your suggestions. You can
      adjust it as needed, and when you're prepared to move forward, simply click 'Let’s Begin!'.
    </Text>
  </>
);

export default YourPlan;
